export type WorkspaceBackgroundVeilMode = 'conversation' | 'empty'

function colorWithAlpha(hexColor: string, alpha: number) {
  const normalized = /^#[0-9a-f]{6}$/i.test(hexColor) ? hexColor : '#F8FAFE'
  const red = Number.parseInt(normalized.slice(1, 3), 16)
  const green = Number.parseInt(normalized.slice(3, 5), 16)
  const blue = Number.parseInt(normalized.slice(5, 7), 16)

  return `rgba(${String(red)}, ${String(green)}, ${String(blue)}, ${String(alpha)})`
}

export function getWorkspaceBackgroundVeil(baseColor: string, mode: WorkspaceBackgroundVeilMode) {
  if (mode === 'empty') {
    return `radial-gradient(ellipse at center, ${colorWithAlpha(baseColor, 0.82)} 0%, ${colorWithAlpha(baseColor, 0.64)} 32%, ${colorWithAlpha(baseColor, 0.06)} 70%)`
  }

  return `linear-gradient(90deg, ${colorWithAlpha(baseColor, 0.08)} 0%, ${colorWithAlpha(baseColor, 0.42)} 15%, ${colorWithAlpha(baseColor, 0.58)} 30%, ${colorWithAlpha(baseColor, 0.58)} 70%, ${colorWithAlpha(baseColor, 0.42)} 85%, ${colorWithAlpha(baseColor, 0.08)} 100%)`
}
